exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button.back-button[data-v-5362ce7b] {\n  margin-bottom: 15px;\n  border: 1px solid #efefef;\n}\n.button.back-button[data-v-5362ce7b]:after {\n  top: 16px;\n}", ""]);

// exports
